<template>
  <modal
    id="modalFornecedor"
    titulo="FINANCEIRO.FORNECEDOR"
    tamanho="xl"
    :exibir="exibir"
    :campos="$refs"
    @fechar="fecharModal"
  >
    <form-dados :form="form" @refs="getRefs" />

    <tabela-formulario-contatos
      :contatos="form.contatos"
      @atualiza-form="atualizaForm"
      @excluir="excluirContatoFornecedor"
      @refs="getRefs"
    />

    <tabela-formulario-enderecos
      :enderecos="form.enderecos"
      @atualiza-form="atualizaForm"
      @excluir="excluirEnderecoFornecedor"
      @refs="getRefs"
    />

    <template #modal-footer>
      <div class="d-flex justify-content-between w-100">
        <b-button variant="secondary" @click="fecharModal">
          {{ $t('GERAL.FECHAR') }}
        </b-button>
        <b-button variant="primary" @click="salvar">
          {{ $t('GERAL.SALVAR') }}
        </b-button>
      </div>
    </template>
  </modal>
</template>

<script>
// Utils & Aux:
import { START_LOADING, STOP_LOADING } from '@/store/Store';
import mensagem from '@/common/utils/mensagem';
import helpers from '@/common/utils/helpers';
import formatador from '@/common/utils/formatador';

// Services:
import EmpresaService from '@/common/services/empresa/empresa.service';

// Components:
import Modal from '@/components/modal/Modal';
import FormDados from './DadosFornecedor';
import TabelaFormularioEnderecos from './TabelaFormularioEnderecos.vue';
import TabelaFormularioContatos from './TabelaFormularioContatos.vue';

export default {
  props: {
    exibir: { type: Boolean, default: false },
    id: { type: String, default: null },
  },
  components: {
    Modal,
    TabelaFormularioEnderecos,
    FormDados,
    TabelaFormularioContatos,
  },
  data() {
    return {
      refs: [],
      form: {
        id: null,
        cnpj: '',
        cpf: '',
        inscricaoMunicipal: '',
        razaoSocial: '',
        nomeFantasia: '',
        contatos: [],
        enderecos: [],
      },
    };
  },
  watch: {
    exibir(value) {
      if (value) {
        this.limparCampos();
        this.getFornecedorPorId();
      }
    },
  },
  methods: {
    // FUNÇÕES VALIDAÇÃO FORMULÁRIO:
    getRefs(refs) {
      this.refs = refs;
    },
    validarFormulario() {
      return helpers.validarFormulario(this.refs);
    },
    // FUNÇÕES CRUD:
    salvar() {
      if (!this.validarFormulario()) return;
      this.form.tipoEmpresa = 'Fornecedor';

      if (this.refs.pessoaFisica.value) 
        this.form.cnpj = null;
      else
        this.form.cpf = null;

      this.form.id ? this.editar() : this.criar();
    },
    criar() {
      // Formatando CNPJ para enviar ao back-end sem pontuação:
      // this.form.cnpj = formatador.cnpjSemPontuacao(this.form.cnpj);

      // Caso não haja contatos nem endereços vinculados:
      if (!this.form.contatos) this.form.contatos = [];
      if (!this.form.enderecos) this.form.enderecos = [];
            
      this.$store.dispatch(START_LOADING);
      EmpresaService.criarFornecedor(this.form)
        .then(() => {
          mensagem.sucesso(this.$t('GERAL.SUCESSO'), 'Fornecedor criado!');
          this.atualizaTabela();
          this.fecharModal();
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
    editar() {
      // Formatando CNPJ para enviar ao back-end sem pontuação:
      if (!this.refs.pessoaFisica.value) 
        this.form.cnpj = formatador.cnpjSemPontuacao(this.form.cnpj);

      this.$store.dispatch(START_LOADING);
      EmpresaService.editarFornecedor(this.form)
        .then(() => {
          mensagem.sucesso(this.$t('GERAL.SUCESSO'), 'Fornecedor editado!');
          this.atualizaTabela();
          this.fecharModal();
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
    excluirEnderecoFornecedor(item) {
      this.form.enderecos.splice(item.index, 1);

      if (this.form.id && item.item.id) {
        this.$store.dispatch(START_LOADING);
        EmpresaService.excluirEnderecoFornecedor(item.item.id)
          .then(() => {
            mensagem.sucesso(this.$t('GERAL.SUCESSO'), 'Endereço excluído!');
          })
          .catch((err) => {
            mensagem.showErrors(err);
          })
          .finally(() => {
            this.$store.dispatch(STOP_LOADING);
          });
      }
    },
    excluirContatoFornecedor(item) {
      this.form.contatos.splice(item.index, 1);

      if (this.form.id && item.item.id) {
        this.$store.dispatch(START_LOADING);
        EmpresaService.excluirContatoFornecedor(item.item.id)
          .then(() => {
            mensagem.sucesso(this.$t('GERAL.SUCESSO'), 'Contato excluído!');
          })
          .catch((err) => {
            mensagem.showErrors(err);
          })
          .finally(() => {
            this.$store.dispatch(STOP_LOADING);
          });
      }
    },
    // FUNÇÃO ATUALIZAÇÃO CONTATO/ENDEREÇO:
    atualizaForm(tipo, objeto) {
      this.form[tipo] = objeto;
    },
    // FUNÇÕES EMISSÃO DE DADOS AO PAI:
    fecharModal() {
      this.$emit('fechar', 'fornecedor');
    },
    atualizaTabela() {
      this.$emit('atualiza-tabela');
    },
    getFornecedorPorId() {
      if (this.id) {
        this.$store.dispatch(START_LOADING);
        EmpresaService.obterFornecedorId(this.id)
          .then(({ data }) => {
            this.form.id = data.id;
            this.form.cnpj = data.cnpj;
            this.form.cpf = data.cpf;
            this.form.inscricaoMunicipal = data.inscricaoMunicipal;
            this.form.razaoSocial = data.razaoSocial;
            this.form.nomeFantasia = data.nomeFantasia;
            this.form.contatos = data.contatos;
            this.form.enderecos = data.enderecos;
          })
          .catch((err) => {
            mensagem.showErrors(err);
          })
          .finally(() => {
            this.$store.dispatch(STOP_LOADING);
          });
        return;
      }
    },
    limparCampos() {
      this.form = {
        id: null,
        cnpj: '',
        cpf: '',
        inscricaoMunicipal: '',
        razaoSocial: '',
        nomeFantasia: '',
        contatos: [],
        enderecos: [],
      };
    },
  },
};
</script>
